import React, { useState } from "react";
import { Nav } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

import "./Sidebar.css";
import { LuLayoutDashboard } from "react-icons/lu";
import { ICONS } from "../../constants/constants";
import { useSelector, useDispatch } from "react-redux";
import { IoMdList } from "react-icons/io";
import { handleLogoutAction } from "../../store/actions/userActions";
import Cookies from "js-cookie";

const Sidebar = ({ isCollapsed }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { user } = useSelector((state) => state.user);
  const userrole = user?.role;
  const userId = user?.id;
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);

  const toggleProfileDropdown = () =>
    setShowProfileDropdown(!showProfileDropdown);

  const isActive = (path) => location.pathname === path;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!userId) return;
    const result = await handleLogoutAction(userId, dispatch);
    if (result) {
      // Clear the auth token from cookies
      Cookies.remove("auth-token");
      navigate("/");
    } else {
      // console.error("Logout failed");
    }
  };

  return (
    <>
      <Nav
        className={`flex-column my-2 sidebar ${isCollapsed ? "collapsed" : ""}`}
      >
        {userrole === "admin" || userrole === "manager" ? (
          <Nav.Link
            as={Link}
            to="/"
            className={`d-flex align-items-center ${
              isActive("/") ? "active" : ""
            }`}
          >
            <LuLayoutDashboard className="SideIcon" />
            {!isCollapsed && <span className="link-text ms-2">Dashboard</span>}
          </Nav.Link>
        ) : (
          <Nav.Link
            as={Link}
            to="/"
            className={`d-flex align-items-center ${
              isActive("/") ? "active" : ""
            }`}
          >
            <LuLayoutDashboard className="SideIcon" />
            {!isCollapsed && <span className="link-text ms-2">Dashboard</span>}
          </Nav.Link>
        )}

        <Nav.Link
          onClick={toggleProfileDropdown}
          style={{ cursor: "pointer" }}
          className="d-flex align-items-center justify-content-between"
        >
          <div className="d-flex align-items-center">
            <img src={ICONS.user} alt="Search" className="Imicon" />
            {/* <FaRegUser className="icon" /> */}
            {!isCollapsed && <span className="link-text ms-2">Users</span>}
          </div>
          {!isCollapsed &&
            (showProfileDropdown ? <FaChevronUp /> : <FaChevronDown />)}
        </Nav.Link>

        {!isCollapsed && showProfileDropdown && (
          <>
            {userrole === "superadmin" && (
              <Nav.Link
                as={Link}
                to="/admins"
                className={`d-flex nested-link align-items-center ${
                  isActive("/admins") ? "active" : ""
                }`}
                key="admins"
              >
                <img
                  // src={ICONS.admins}
                  src={isActive("/admins") ? ICONS.activeAdmins : ICONS.admins}
                  alt="Search"
                  className="Imicon"
                />
                {/* <GrUserWorker className="icon" /> */}
                <span className="link-text ms-2">Admins</span>
              </Nav.Link>
            )}
            {userrole === "superadmin" && (
              <Nav.Link
                as={Link}
                to="/managers"
                className={`d-flex nested-link align-items-center ${
                  isActive("/managers") ? "active" : ""
                }`}
                key="managers"
              >
                <img
                  src={isActive("/managers") ? ICONS.activeAdmins : ICONS.admins}
                  alt="Search"
                  className="Imicon"
                />
                <span className="link-text ms-2">Managers</span>
              </Nav.Link>
            )}
            <Nav.Link
              as={Link}
              to="/farmers"
              className={`d-flex nested-link align-items-center ${
                isActive("/farmers") ? "active" : ""
              }`}
              key="farmers"
            >
              <img
                // src={ICONS.farmer}
                src={isActive("/farmers") ? ICONS.activeFarmer : ICONS.farmer}
                alt="Search"
                className="Imicon"
              />
              {/* <GrUserWorker className="icon" /> */}
              <span className="link-text ms-2">Farmers</span>
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/suppliers"
              className={`d-flex nested-link align-items-center ${
                isActive("/suppliers") ? "active" : ""
              }`}
              key="suppliers"
            >
              <img
                // src={ICONS.supplier}
                src={
                  isActive("/suppliers") ? ICONS.activeSupplier : ICONS.supplier
                }
                alt="Search"
                className="Imicon"
              />
              {/* <FaUserNurse className="icon" /> */}
              <span className="link-text ms-2">Suppliers</span>
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/consultants"
              className={`d-flex nested-link align-items-center ${
                isActive("/consultants") ? "active" : ""
              }`}
              key="consultants"
            >
              <img
                // src={ICONS.consultant}
                src={
                  isActive("/consultants")
                    ? ICONS.activeConsultant
                    : ICONS.consultant
                }
                alt="Search"
                className="Imicon"
              />
              {/* <FaUserCog className="icon" /> */}
              <span className="link-text ms-2">Consultants</span>
            </Nav.Link>
            {/* <Nav.Link
              as={Link}
              to="/others"
              className={`d-flex nested-link align-items-center ${
                isActive("/others") ? "active" : ""
              }`}
              key="others"
            >
              <img 
              src={isActive("/others") ? ICONS.activeOther : ICONS.other}
               alt="Search" className="Imicon" />
              <span className="link-text ms-2">Others</span>
            </Nav.Link> */}
          </>
        )}
        {userrole === "superadmin" && (
          <Nav.Link
            as={Link}
            to="/inputs-required"
            className={`d-flex align-items-center ${
              isActive("/inputs-required") ? "active" : ""
            }`}
          >
            <img
              // src={ICONS.input}
              src={
                isActive("/inputs-required")
                  ? ICONS.activeNotification
                  : ICONS.input
              }
              alt="Search"
              className="Imicon"
            />
            {!isCollapsed && (
              <span className="link-text ms-2">Inputs Required</span>
            )}
          </Nav.Link>
        )}
        {userrole === "superadmin" && (
          <>
          <Nav.Link
            as={Link}
            to="/manage-crops"
            className={`d-flex align-items-center ${
              isActive("/manage-crops") ? "active" : ""
            }`}
          >
            <img src={ICONS.crops} alt="Search" className="Imicon" />
            {/* <CiDollar className="icon" /> */}
            {!isCollapsed && (
              <span className="link-text ms-2">Manage Crops</span>
            )}
          </Nav.Link>

          <Nav.Link
            as={Link}
            to="/manage-regions"
            className={`d-flex align-items-center ${
              isActive("/manage-regions") ? "active" : ""
            }`}
          >
            <img src={ICONS.regionIcon} alt="Search" className="Imicon" />
            {/* <CiDollar className="icon" /> */}
            {!isCollapsed && (
              <span className="link-text ms-2">Regions</span>
            )}
          </Nav.Link>

          <Nav.Link
            as={Link}
            to="/manage-schedualers"
            className={`d-flex align-items-center ${
              isActive("/manage-schedualers") ? "active" : ""
            }`}
          >
            <img src={ICONS.schedualerIcon} alt="Search" className="Imicon" />
            {/* <CiDollar className="icon" /> */}
            {!isCollapsed && (
              <span className="link-text ms-2">Schedulers</span>
            )}
          </Nav.Link>

          </>
        )}

        {/* {userrole === "superadmin" && (
          <Nav.Link
            as={Link}
            to="/finance"
            className={`d-flex align-items-center ${
              isActive("/finance") ? "active" : ""
            }`}
          >
            <img src={ICONS.finance} alt="Search" className="Imicon" />
            {!isCollapsed && <span className="link-text ms-2">Finance</span>}
          </Nav.Link>
        )} */}
        {userrole !== "manager" && (
          <Nav.Link
            as={Link}
            to="/notifications"
            className={`d-flex align-items-center ${
              isActive("/notifications") ? "active" : ""
            }`}
          >
            <img src={ICONS.Notification} alt="Search" className="icon Imicon" />
            {!isCollapsed && (
              <span className="link-text ms-2">Notifications</span>
            )}
          </Nav.Link>
        )}

        <Nav.Link
          as={Link}
          to="/settings"
          className={`d-flex align-items-center ${
            isActive("/settings") ? "active" : ""
          }`}
        >
          <img src={ICONS.setting} alt="Search" className="Imicon" />
          {!isCollapsed && <span className="link-text ms-2">Settings</span>}
        </Nav.Link>
        <Nav.Link
          as={Link}
          className={`d-flex align-items-center ${
            isActive("/signout") ? "active" : ""
          }`}
          onClick={handleSubmit}
        >
          <img src={ICONS.logout} alt="Sign Out" className="Imicon" />
          {!isCollapsed && <span className="link-text ms-2">Sign Out</span>}
        </Nav.Link>
      </Nav>
    </>
  );
};

export default Sidebar;
